import { defineMessages, type MessageDescriptor } from 'react-intl-next';

const messages: Record<
	| 'inferredProject'
	| 'inferredProjectTrigger'
	| 'loading'
	| 'loadError'
	| 'basedOnPrefix'
	| 'teamworkGraphActivityAndSource'
	| 'sourcedFrom'
	| 'suggestedContributors'
	| 'noSuggestedContributors'
	| 'showAllContributors'
	| 'claimProjectDescription'
	| 'claimProject'
	| 'claimProjectError'
	| 'viewProject'
	| 'copyLink'
	| 'linkCopied'
	| 'project'
	| 'projectTrigger'
	| 'sourcesAndRelatedLinks'
	| 'owner'
	| 'contributors'
	| 'noContributors'
	| 'projectConfirmed',
	MessageDescriptor
> = defineMessages({
	inferredProject: {
		defaultMessage: 'Suggested project',
		description: 'Label shown on the inferred project card and inline project chip',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.inferredProject',
	},
	inferredProjectTrigger: {
		defaultMessage: '{projectName}: Suggested project',
		description: 'Accessible label for the suggested project chip trigger',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.inferredProjectTrigger',
	},
	loading: {
		defaultMessage: 'Loading project details',
		description: 'Status shown while inferred project details load',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.loading',
	},
	loadError: {
		defaultMessage: 'Project details could not be loaded.',
		description: 'Error shown when inferred project details fail to load',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.loadError',
	},
	basedOnPrefix: {
		defaultMessage: 'based on',
		description: 'Prefix for the inferred project source attribution',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.basedOnPrefix',
	},
	teamworkGraphActivityAndSource: {
		defaultMessage: 'Teamwork Graph activity and this source',
		description: 'Source attribution for an inferred project based on Teamwork Graph activity',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.teamworkGraphActivityAndSource',
	},
	sourcedFrom: {
		defaultMessage: 'sourced from',
		description: 'Sourced from text for an inferred project based on Teamwork Graph activity',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.sourcedFrom',
	},
	suggestedContributors: {
		defaultMessage: 'Suggested contributors',
		description: 'Heading for the inferred project contributors section',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.suggestedContributors',
	},
	noSuggestedContributors: {
		defaultMessage: 'No suggested contributors',
		description: 'Empty state for the inferred project contributors section',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.noSuggestedContributors',
	},
	showAllContributors: {
		defaultMessage: 'Show all',
		description: 'Action to reveal all suggested contributors for an inferred project',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.showAllContributors',
	},
	claimProjectDescription: {
		defaultMessage: 'Claim this project so your team can track it together.',
		description: 'Supporting text above the action to promote an inferred project',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.claimProjectDescription',
	},
	claimProject: {
		defaultMessage: 'Claim this project',
		description: 'Action that promotes an inferred project to an Atlas project',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.claimProject',
	},
	claimProjectError: {
		defaultMessage: 'Error. Try again later.',
		description: 'Error shown when an inferred project cannot be promoted',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.claimProjectError',
	},
	viewProject: {
		defaultMessage: 'View project',
		description: 'Action that opens the promoted Atlas project',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.viewProject',
	},
	copyLink: {
		defaultMessage: 'Copy link',
		description: 'Action that copies the promoted Atlas project link',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.copyLink',
	},
	linkCopied: {
		defaultMessage: 'Link copied',
		description: 'Confirmation shown after the promoted Atlas project link is copied',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.linkCopied',
	},
	project: {
		defaultMessage: 'Project',
		description: 'Label shown after an inferred project has been promoted',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.project',
	},
	projectTrigger: {
		defaultMessage: '{projectName}: Project',
		description: 'Accessible label for the project chip after promotion',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.projectTrigger',
	},
	sourcesAndRelatedLinks: {
		defaultMessage: 'Sources and related links',
		description: 'Action that shows the source links for a promoted project',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.sourcesAndRelatedLinks',
	},
	owner: {
		defaultMessage: 'Owner',
		description: 'Heading for the promoted project owner',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.owner',
	},
	contributors: {
		defaultMessage: 'Contributors',
		description: 'Heading for the promoted project contributors',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.contributors',
	},
	noContributors: {
		defaultMessage: 'No contributors',
		description: 'Empty state for the promoted project contributors',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.noContributors',
	},
	projectConfirmed: {
		defaultMessage: 'Project confirmed',
		description: 'Confirmation shown after an inferred project is promoted',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.projectConfirmed',
	},
});

export default messages;
